import React, { useCallback, useMemo } from "react";
import { FinancialConnectionWithAccounts } from "@common/types/financialConnection";
import { useLatestBalanceSyncTime } from "@hooks/useLatestSyncTime";
// oxlint-disable-next-line no-restricted-imports -- Legacy migration debt — do not copy into new code.
import { Collapsible } from "@design-system/Collapsible/Collapsible";
import { InstitutionIcon } from "@design-system/InstitutionIcon/InstitutionIcon";
import { timeAgo } from "@helpers/date";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { ClockIcon } from "@icons";
import { DisplayIntegrationAccount } from "../integrationAccount/DisplayIntegrationAccount";
import css from "./GustoConnectionsStatus.module.scss";
import { CreateGustoConnection } from "./CreateGustoConnection";

interface Props {
    gustoConnections: FinancialConnectionWithAccounts[];
}

export const GustoConnectionsStatus: React.FC<Props> = ({
    gustoConnections,
}) => {
    const { toast } = useToaster();

    const handleConnected = useCallback(() => {
        toast(`Gusto connected`);
    }, [toast]);

    const accounts = useMemo(
        () => gustoConnections.map((c) => c.accounts[0]),
        [gustoConnections],
    );
    const mostRecentBalanceSyncedAt = useLatestBalanceSyncTime(accounts);

    const header = (
        <div className={css.header}>
            <InstitutionIcon institution="gusto" size="lg" />
            <main>
                <h5>Gusto</h5>
                {mostRecentBalanceSyncedAt && (
                    <small>
                        <ClockIcon
                            height={12}
                            width={12}
                            className="icon-color-current"
                        />
                        {timeAgo(mostRecentBalanceSyncedAt)}
                    </small>
                )}
            </main>
        </div>
    );

    return (
        <Collapsible
            className={css.gustoConnections}
            header={header}
            footer={
                <div className={css.footerSection}>
                    <CreateGustoConnection
                        btnVariant="primary"
                        onCreated={handleConnected}
                    >
                        Add another account
                    </CreateGustoConnection>
                </div>
            }
        >
            <>
                {gustoConnections?.map((connection) => (
                    <DisplayIntegrationAccount
                        key={connection.id}
                        className={css.displayAccount}
                        connection={connection}
                        integrationAccount={connection.accounts[0]}
                    />
                ))}
            </>
        </Collapsible>
    );
};
